import { EMPTY_STRING, toastMessages } from "../../../constants";
import { CustomCellRendererWithSkeleton } from "../../components";
import {
  getFormattedCondition,
  getProductTagColumn,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";

const getNewReturnColumns = (props) => {
  const { handleInputFieldTable } = props;
  return [
    {
      id: "name",
      name: "Name",
      selector: (row) => row.itemName,
      cell: (row) => (
        <CustomCellRendererWithSkeleton
          cellComponent={row.itemName}
          cellComponentClassName={row.isReturn === false && "opacity-50"}
          componentRenderCondition={true}
          titleToolTipText={
            row.isReturn === false
              ? toastMessages.GIFT_CARD_CANNOT_BE_RETURNED
              : row.itemName
          }
        />
      ),
      sortable: true,
      sortDirection: null,
      width: "40%",
    },
    {
      id: "price",
      name: "Price",
      selector: (row) => row.priceAfterGlobalDiscount,
      cell: (row) => (
        <CustomCellRendererWithSkeleton
          cellComponent={`$${parseToThousandSeperatorDecimalNumber(
            row.priceAfterGlobalDiscount
          )}`}
          cellComponentClassName={row.isReturn === false && "opacity-50"}
          componentRenderCondition={true}
          titleToolTipText={
            row.isReturn === false
              ? toastMessages.GIFT_CARD_CANNOT_BE_RETURNED
              : EMPTY_STRING
          }
        />
      ),
      sortable: true,
      sortDirection: null,
      width: "10%",
    },
    {
      id: "category",
      name: "Category",
      selector: (row) => row.category,
      cell: (row) => (
        <CustomCellRendererWithSkeleton
          cellComponent={
            row.isReturn === false ? EMPTY_STRING : `${row.category}`
          }
          componentRenderCondition={true}
          titleToolTipText={row.category}
        />
      ),
      sortable: true,
      sortDirection: null,
      width: "10%",
    },
    {
      id: "condition",
      name: "Condition",
      selector: (row) => row.condition,
      cell: (row) => (
        <CustomCellRendererWithSkeleton
          cellComponent={
            row.isReturn === false ? "" : `${getFormattedCondition(row)}`
          }
          componentRenderCondition={true}
        />
      ),
      sortable: true,
      sortDirection: null,
      width: "10%",
    },
    getProductTagColumn("tags", false, { width: "10%" }),
    {
      id: "available",
      name: "Available",
      selector: (row) => row.quantity,
      cell: (row) => (
        <CustomCellRendererWithSkeleton
          cellComponent={
            <span
              className={`inventory-cell-max-size ${
                row.isReturn === false ? "opacity-50" : ""
              }`}
            >
              {row.quantity}
            </span>
          }
          cellComponentClassName={row.isReturn === false && "opacity-50"}
          componentRenderCondition={true}
          titleToolTipText={
            row.isReturn === false
              ? toastMessages.GIFT_CARD_CANNOT_BE_RETURNED
              : EMPTY_STRING
          }
        />
      ),
      sortable: true,
      sortDirection: null,
      width: "10%",
    },
    {
      id: "editQty",
      name: "Edit QTY",
      selector: (row) => row.editQTY,
      cell: (row) => {
        return (
          <CustomCellRendererWithSkeleton
            cellComponent={
              <input
                className={`input-textfield-table `}
                autoComplete="off"
                type="number"
                min={0}
                value={row.editQTY}
                onChange={(e) =>
                  handleInputFieldTable(row.sku, row.maxValue, e.target.value)
                }
                disabled={row.isReturn === false}
              />
            }
            cellComponentClassName={row.isReturn === false && "opacity-50"}
            componentRenderCondition={true}
            titleToolTipText={
              row.isReturn === false
                ? toastMessages.GIFT_CARD_CANNOT_BE_RETURNED
                : EMPTY_STRING
            }
          />
        );
      },
      width: "10%",
    },
  ];
};

export { getNewReturnColumns };
